import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { VexPopoverService } from 'src/@vex/components/vex-popover/vex-popover.service';
import { ToolbarNotificationsDropdownComponent } from './toolbar-notifications-dropdown/toolbar-notifications-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { NotificationStateService } from './notification-shared-service.service';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'vex-toolbar-notifications',
  templateUrl: './toolbar-notifications.component.html',
  styleUrls: ['./toolbar-notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, MatIconModule,CommonModule],
})
export class ToolbarNotificationsComponent implements OnInit {
  @ViewChild('originRef', { static: true, read: ElementRef }) originRef: ElementRef;
  private intervalId: any;

  dropdownOpen: boolean;
  @Input("notificationCount") notificationCount$: Observable<number>;
  @Input("notificationTotalCount") notificationTotalCount$: Observable<number>;
  unreadCount: number = 0;
  currentUserId: string;
  isRtl: boolean = false;

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private notificationService: NotificationService,
    private authService: AuthService,
    private notificationStateService: NotificationStateService,
    private translateService:TranslateService,
  ) {}

  ngOnInit() 
  {
    this.isRtl = this.translateService.currentLang == 'ar'|| this.translateService.currentLang == 'ur'?true:false;
    this.requestNotificationPermission();  // Request permission on initialization
    this.startPolling();

  }
  ngOnDestroy() {
    this.stopPolling();
  }

  getUnreadNotificationsCount()
  {
    this.currentUserId = this.authService.currentUserValue.id;
  
    this.notificationService.getUnreadNotificationsCount(this.currentUserId).subscribe(response=>{
        this.notificationCount$ = response.data.count; 
        //this.unreadCount = response.data.count;
        const newUnreadCount = response.data.count;
        const oldUnreadCount = this.unreadCount;

        if(localStorage.getItem('oldUnreadCount') !== null && Number(localStorage.getItem('oldUnreadCount')) < newUnreadCount) {
      localStorage.setItem('oldUnreadCount', oldUnreadCount.toString());
    }
    else if(localStorage.getItem('oldUnreadCount') !== null){
      localStorage.setItem('oldUnreadCount', localStorage.getItem('oldUnreadCount'));

    }
    else{
      localStorage.setItem('oldUnreadCount', '0'.toString());

    }
      // If the count has increased, trigger a browser notification
      if (newUnreadCount > Number(localStorage.getItem('oldUnreadCount'))) {
        this.showBrowserNotification(newUnreadCount);
      } 
      this.unreadCount = newUnreadCount;

        //this.showBrowserNotification(this.unreadCount);

        this.notificationStateService.setUnreadCount(this.notificationCount$);
        this.cd.markForCheck(); 
    });

}

// Show a browser notification when the unread count increases
showBrowserNotification(newUnreadCount: number): void {
  if (Notification.permission === 'granted') {
    const options: NotificationOptions = {
      body: this.isRtl?`لديك ${newUnreadCount} إشعارًا غير مقروء`:`You have ${newUnreadCount} unread notifications!`,
      icon: 'assets/notification-icon.png', // Customize the icon if necessary
    };
    new Notification(this.isRtl?'إشعار جديد':'New Notification', options);
  }
}

startPolling(): void {
  this.getUnreadNotificationsCount(); // Initial call
  this.intervalId = setInterval(() => {
    this.getUnreadNotificationsCount();
  }, 15000); // 15 seconds
}

// Request notification permission
requestNotificationPermission(): void {
  if ('Notification' in window) {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.log('Notification permission granted');
      } else {
        console.warn('Notification permission denied');
      }
    });
  } else {
    console.error('This browser does not support notifications.');
  }
}

stopPolling(): void {
  if (this.intervalId) {
    clearInterval(this.intervalId);
  }
}
  showPopover() {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarNotificationsDropdownComponent,
      origin: this.originRef,
      offsetY: 12,
      data: this.notificationCount$,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.getUnreadNotificationsCount();
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
